import { render, staticRenderFns } from "./LoadDocument.vue?vue&type=template&id=474a0fde&scoped=true&"
import script from "./LoadDocument.ts?vue&type=script&lang=ts&"
export * from "./LoadDocument.ts?vue&type=script&lang=ts&"
import style0 from "./LoadDocument.scss?vue&type=style&index=0&id=474a0fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474a0fde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
